import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const HR_NAV = [
  { to: '/',            icon: '⊞', label: 'Dashboard'  },
  { to: '/employees',   icon: '👥', label: 'Employees'  },
  { to: '/managers',    icon: '👤', label: 'Managers'   },
  { to: '/projects',    icon: '📁', label: 'Projects'   },
  { to: '/clients',     icon: '🏢', label: 'Clients'    },
  { to: '/reports',     icon: '📊', label: 'Reports'    },
  { to: '/utilization', icon: '📈', label: 'Utilization' },
  { to: '/pli',         icon: '💰', label: 'PLI'         },
];

const MGR_NAV = [
  { to: '/',        icon: '⊞', label: 'Dashboard' },
  { to: '/reports', icon: '🗓', label: 'My Team'   },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [col, setCol] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const nav = user?.role === 'manager' ? MGR_NAV : HR_NAV;

  const handleLogout = () => { logout(); toast.success('Logged out.'); navigate('/login'); };

  return (
    <div className="layout">
      <aside className={`sidebar ${col ? 'collapsed' : ''}`}>
        <div className="sb-header">
          <div className="sb-logo">
            <div className="sb-logo-icon">{user?.role === 'manager' ? 'MGR' : 'HR'}</div>
            {!col && <span className="sb-logo-text">{user?.role === 'manager' ? 'Manager' : 'HR'} Portal</span>}
          </div>
          <button className="sb-toggle" onClick={() => setCol(!col)}>{col ? '→' : '←'}</button>
        </div>

        <nav className="sb-nav">
          {nav.map(item => (
            <NavLink key={item.to} to={item.to} end={item.to==='/'} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">{item.icon}</span>
              {!col && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sb-footer" style={{ position:'relative', flexDirection:'column', alignItems:'stretch', gap:0, padding:'8px' }}>
          <button
            onClick={() => setProfileOpen(p => !p)}
            style={{ display:'flex', alignItems:'center', gap:8, background:'none', border:'1px solid transparent', borderRadius:10, padding:'8px 10px', cursor:'pointer', width:'100%', transition:'all .15s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor='#2a2d3a'}
            onMouseLeave={e => e.currentTarget.style.borderColor='transparent'}
          >
            <div className="avatar">{user?.name?.charAt(0)}</div>
            {!col && (
              <div style={{ flex:1, textAlign:'left', overflow:'hidden' }}>
                <div className="sb-user-name">{user?.name}</div>
                <div className="sb-user-role" style={{ textTransform:'capitalize' }}>{user?.role}</div>
              </div>
            )}
            {!col && <span style={{ color:'#6b7280', fontSize:12 }}>{profileOpen ? '▲' : '▼'}</span>}
          </button>

          {profileOpen && (
            <div style={{ position:'absolute', bottom:'100%', left:8, right:8, background:'#22263a', border:'1px solid #2a2d3a', borderRadius:10, overflow:'hidden', marginBottom:4, boxShadow:'0 -8px 24px rgba(0,0,0,.4)', zIndex:200 }}>

              <button
                onClick={handleLogout}
                style={{ display:'flex', alignItems:'center', gap:10, width:'100%', padding:'11px 14px', background:'none', border:'none', color:'#ef4444', fontSize:13, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}
                onMouseEnter={e => e.currentTarget.style.background='rgba(239,68,68,.08)'}
                onMouseLeave={e => e.currentTarget.style.background='none'}
              >
                ⏻ Logout
              </button>
            </div>
          )}
        </div>
      </aside>

      <main className="main">{children}</main>
    </div>
  );
}